export default __webpack_public_path__ + "static/media/telegram.409c45c1.png";